// GENERATED by extract_demo_data.py — do not edit by hand.
//
// VERBATIM ONLY. Every utterance, quote and concept string below is copied out of a real
// exam ledger or the Card. Nothing is written for the demo, nothing is paraphrased and
// nothing is tidied. tests/test_demo_data_is_verbatim.py re-reads the source logs in
// data/checkride_v6/demo_runs/ and fails on any string that is not in them byte for byte.
//
// Source: the three exams that walked the full flight through exam_server.py IN PARALLEL
// on 2026-10-01 — the first three orals this system served over a WebSocket.

export interface Utterance { who: "examiner" | "applicant"; said: string; turn: number }
export interface MomentStep { index: number; label: string; turns: number }
export interface Clarification {
  sessionId: string; asked: string; examinerReplied: string; free: boolean;
}
export interface ProofMoment {
  id: string; sessionId: string; applicant: string; examiner: string;
}
export interface RunSummary {
  persona: string; sessionId: string; utterances: number; questions: number;
  turns: number; itemsAsked: number; zeroCredit: number; momentsWalked: number;
  momentsTotal: number; reached: string; medianTurnSecs: number | null;
  determination: string;
}

export const runs: RunSummary[] = [
  {
    "persona": "steady",
    "sessionId": "20261001_190351_46ac35",
    "utterances": 148,
    "questions": 78,
    "turns": 83,
    "itemsAsked": 29,
    "zeroCredit": 0,
    "momentsWalked": 9,
    "momentsTotal": 9,
    "reached": "arriving at Easton",
    "medianTurnSecs": 8.2,
    "determination": "DETERMINATION, per ACS Task:\n  pilot: UNSAT — 1 of 1 Skill elements unproved\n  aircraft: UNSAT — 1 of 3 Skill elements unproved\n  weather: UNSAT — 2 of 4 Skill elements unproved\n  xc_plan: SAT\n  airspace: SAT\n  performance: SAT\n  systems: UNSAT — no Risk element proved\n  aeromedical: SAT"
  },
  {
    "persona": "questioning",
    "sessionId": "20261001_190352_19fce4",
    "utterances": 179,
    "questions": 91,
    "turns": 95,
    "itemsAsked": 30,
    "zeroCredit": 0,
    "momentsWalked": 9,
    "momentsTotal": 9,
    "reached": "arriving at Easton",
    "medianTurnSecs": 8.3,
    "determination": "DETERMINATION, per ACS Task:\n  pilot: SAT\n  aircraft: UNSAT — 1 of 3 Skill elements unproved\n  weather: UNSAT — 1 of 4 Skill elements unproved\n  xc_plan: SAT\n  airspace: UNSAT — 1 of 3 Skill elements unproved\n  performance: SAT\n  systems: SAT\n  aeromedical: SAT"
  },
  {
    "persona": "hesitant",
    "sessionId": "20261001_190353_1bd997",
    "utterances": 169,
    "questions": 88,
    "turns": 93,
    "itemsAsked": 31,
    "zeroCredit": 0,
    "momentsWalked": 9,
    "momentsTotal": 9,
    "reached": "arriving at Easton",
    "medianTurnSecs": 8.1,
    "determination": "DETERMINATION, per ACS Task:\n  pilot: UNSAT — no Risk element proved\n  aircraft: UNSAT — 2 of 3 Skill elements unproved\n  weather: UNSAT — 1 of 4 Skill elements unproved\n  xc_plan: SAT\n  airspace: SAT\n  performance: SAT\n  systems: UNSAT — no Risk element proved\n  aeromedical: UNSAT — 1 of 2 Skill elements unproved"
  }
];

export const momentWalk: MomentStep[] = [
  {
    "index": 1,
    "label": "at the FBO, before we walk out",
    "turns": 10
  },
  {
    "index": 2,
    "label": "at the airplane with the logbooks open",
    "turns": 12
  },
  {
    "index": 3,
    "label": "at the planning table, going through the weather",
    "turns": 7
  },
  {
    "index": 4,
    "label": "at the planning table, building the route and the airspace",
    "turns": 24
  },
  {
    "index": 5,
    "label": "at the planning table, weight, balance and performance",
    "turns": 7
  },
  {
    "index": 6,
    "label": "the go/no-go, before we walk out to the airplane",
    "turns": 10
  },
  {
    "index": 7,
    "label": "in the cockpit, before start",
    "turns": 6
  },
  {
    "index": 8,
    "label": "en route over the bay, as the weather closes in",
    "turns": 13
  },
  {
    "index": 9,
    "label": "arriving at Easton",
    "turns": 5
  }
];

export const featuredSessionId = "20261001_190352_19fce4";

export const transcript: Utterance[] = [
  {
    "who": "applicant",
    "said": "Morning. I'm ready whenever you are.",
    "turn": 0
  },
  {
    "who": "examiner",
    "said": "Morning. Let's start with your two passengers to Easton. If they offer to chip in for the trip, what can you legally accept from them as a private pilot, and where's the line?",
    "turn": 1
  },
  {
    "who": "applicant",
    "said": "As a private pilot, I can accept a pro-rata share of the operating costs — fuel, oil, that kind of thing. What I can't do is make a profit or charge them a fee on top of my costs. The line is: I can only accept what it actually costs me to operate the airplane for that flight, split among the people on board.",
    "turn": 1
  },
  {
    "who": "examiner",
    "said": "You said \"fuel, oil, that kind of thing.\" Be specific: if you're renting N5124K for this trip, what exactly is in the pot that you three can split, and what isn't?",
    "turn": 2
  },
  {
    "who": "applicant",
    "said": "I need to clarify — are you asking what costs I can split if I'm renting the airplane, or are you asking about the operating costs of this specific flight in N5124K? Because if I'm renting, the rental fee itself is one thing, but if I'm talking about what we split on a flight I'm operating, that's different.",
    "turn": 2
  },
  {
    "who": "examiner",
    "said": "Fair question. Forget whether it's rented or owned for a moment. The regulation lists specific kinds of expenses a private pilot can share with passengers. I want that list. Which categories of cost does the rule allow, and is there anything else the flight has to meet before you can share costs at all?",
    "turn": 3
  },
  {
    "who": "applicant",
    "said": "The regulation allows me to share fuel, oil, airport fees, and aircraft rental costs — the direct operating costs. But before I can share anything, the flight has to be non-commercial and I can't be receiving any compensation; the flight has to be for my own purposes, and the passengers are just along for the ride, not paying me to fly them.",
    "turn": 3
  },
  {
    "who": "examiner",
    "said": "Good, that's the list. Now suppose your two friends cancel and you fly to Easton alone, and a buddy who stayed home offers to pay half the fuel. Can you take it? Tell me why or why not.",
    "turn": 4
  },
  {
    "who": "applicant",
    "said": "No, I can't take it. The regulation says passengers can share costs only if they're on the flight with me — they have to be actually flying to help defray the direct operating expenses of that flight. Your friend at home isn't a passenger on this trip, so he can't contribute.",
    "turn": 4
  },
  {
    "who": "examiner",
    "said": "Good. Now step back from the money. As a private pilot with 55 hours, what are you allowed to do with this airplane today, and what limits that? Think about the passengers, the weather, and the purpose of the trip.",
    "turn": 5
  },
  {
    "who": "applicant",
    "said": "As a private pilot I can carry passengers for non-commercial purposes — that's what I'm doing today with two friends to Easton. But I have limits: I need at least a current medical and a valid license, my passengers can't exceed the aircraft's weight and balance, and the weather has to be within VFR minimums.",
    "turn": 5
  },
  {
    "who": "examiner",
    "said": "You've told me what you can't do. Two things I want to hear. First, what role does your certificate let you hold in N5124K today? Second, apart from cost sharing, are there any other situations where a private pilot can legally be paid or reimbursed for flying?",
    "turn": 6
  },
  {
    "who": "applicant",
    "said": "As a private pilot, I can act as pilot in command of N5124K today — that's the role my certificate lets me hold. And yes, there are situations where I can be reimbursed: if I'm flying an aircraft I own or operate, I can be reimbursed for certain expenses like fuel or tie-down, as long as it doesn't turn into a commercial operation.",
    "turn": 6
  },
  {
    "who": "examiner",
    "said": "Not quite. Owning the airplane doesn't, on its own, let you be reimbursed. The rule allows paid flying only in a short list of specific exceptions. Cost sharing is one of them. Name me any others you know. For example, think about flying for your employer, charity events, search and rescue, or towing gliders.",
    "turn": 7
  },
  {
    "who": "applicant",
    "said": "I want to make sure I'm answering what you're asking. Are you asking me to name the specific FAA exceptions where a private pilot can be paid or reimbursed — like Part 61.113(c) situations — or are you asking which of those examples you mentioned I'm allowed to do today on this flight?",
    "turn": 7
  },
  {
    "who": "examiner",
    "said": "The first one. Leave today's flight aside. In general, what are the exceptions where a private pilot may be paid or reimbursed, and how broad is that list?",
    "turn": 8
  },
  {
    "who": "applicant",
    "said": "The main exceptions are in 61.113(c): you can be paid to fly for your employer if the flight is incidental to your job, you can be reimbursed for expenses on an aircraft you own, and you can tow a glider or banner for compensation. Search and rescue is allowed but typically not paid. The list is pretty narrow — basically those four categories.",
    "turn": 8
  },
  {
    "who": "examiner",
    "said": "Two corrections before we move on. Owning the airplane is not an exception. Banner towing isn't one either: that's commercial work. Glider towing is allowed only under specific conditions. Search and rescue can actually be reimbursed for operating expenses. All right, now you. Before you fly your friends to Easton this afternoon, walk me through the personal checklist you'd run on yourself, every element.",
    "turn": 9
  },
  {
    "who": "applicant",
    "said": "Got it—thank you for those corrections. So before I fly N5124K to KESN this afternoon with my passengers, I'd run through a personal preflight that covers several things. First, I check my medical certificate—mine is Class 3 and current through September 2030, so I'm good there. Second, I verify my currency: I have 55 hours total time with 12 hours PIC, and my logbook shows 12 day landings in the last 90 days, so I meet the recency requirements for this day VFR flight. Third, I'd confirm I haven't had any disqualifying medical events or medications since my last medical—nothing applies here. Fourth, I check that I'm not fatigued or impaired, and that I'm mentally fit to fly; I'm well-rested and have reviewed the weather and route thoroughly.",
    "turn": 9
  },
  {
    "who": "examiner",
    "said": "That's paperwork and currency. I'm asking about you, the body in the left seat. There's a standard memory aid pilots use to check their own fitness before a flight. Give me the acronym, and tell me what each letter stands for.",
    "turn": 10
  },
  {
    "who": "applicant",
    "said": "That's IMSAFE: Illness, Medication, Stress, Alcohol, Fatigue, and Eating. I'd check each one before getting in the left seat today.",
    "turn": 10
  },
  {
    "who": "examiner",
    "said": "Say you're doing your walkaround on N5124K and something on it doesn't work. This airplane has no MEL. Walk me through how you decide whether you can still take it to Easton today.",
    "turn": 11
  },
  {
    "who": "applicant",
    "said": "Okay, so N5124K has no MEL, which means I have to go by Part 91.7 and the Airworthiness Certificate—basically, the aircraft has to be airworthy. If I find something broken on the walkaround, I need to figure out: first, is this system required for the kind of flight I'm doing? For example, if it's a landing light and I'm doing a day flight, that's not required under 91.205. But if it's something like the pitot tube or static port, or an engine instrument, those are required for any flight. Second, I'd check the POH to see if the system is listed as essential for safe operation—the Cessna 172S manual is pretty clear about what you need. Third, I'd consider whether it affects my ability to operate safely in today's conditions—we've got MVFR, icing risk, a Chesapeake Bay crossing, and I'm flying into a military airport at KNAK, so I can't be casual about it.",
    "turn": 11
  },
  {
    "who": "examiner",
    "said": "You're thinking along the right lines, but give me the actual regulation that covers flying with inoperative equipment. Then tell me: once you've decided the broken item isn't required, what do you physically do with it before you take off? And how would the process differ if this airplane did have an MEL?",
    "turn": 12
  },
  {
    "who": "applicant",
    "said": "That's 14 CFR 91.213(d)—if equipment is inoperative and not required for the flight, I can deactivate it, placard it, and log it in the maintenance record. If N5124K had an MEL, I'd follow the specific procedures in that MEL instead, which might allow operation under different conditions than Part 91.213 would.",
    "turn": 12
  },
  {
    "who": "examiner",
    "said": "One more piece. You've found it, decided it isn't required, and you've got a plan to deactivate and placard it. Can you start the engine and depart, and do that paperwork once you land in Easton? Or does something have to happen first? When does all of that have to be finished?",
    "turn": 13
  },
  {
    "who": "applicant",
    "said": "No, I need to finish all of that before I start the engine. The regulation says the equipment has to be deactivated and placarded, and I have to make an entry in the maintenance record—that all happens on the ground before departure. Once I've done that, then I can legally start up and go.",
    "turn": 13
  },
  {
    "who": "examiner",
    "said": "Here's what you actually find. During the walkaround and run-up on N5124K, the vacuum pump is dead. The attitude indicator and heading indicator never come alive. Everything else on the airplane is fine, and there's no MEL. Talk me through it. Are we going to Easton today, and if we are, what do you have to do first?",
    "turn": 15
  },
  {
    "who": "applicant",
    "said": "Okay, so the vacuum pump is inoperative, which means both the attitude indicator and heading indicator are out. Let me think through this carefully. First, I need to determine whether those instruments are required for this flight. I'm filing VFR, day flight, 64 nautical miles from Montgomery County to Easton—no IFR, no night operations. Under 14 CFR 91.205, for day VFR flight, I need airspeed, altitude, and direction—the heading indicator isn't actually required. The attitude indicator also isn't on the required list for VFR day. So both of these inoperative instruments are not required equipment for today's flight under Part 91.205(b). That means I can legally operate under 91.213(d). But before I touch the ignition switch, I have to deactivate both instruments—I'll pull the breakers or switch them off—and I have to placard each one clearly so nobody tries to use them in flight.",
    "turn": 15
  },
  {
    "who": "examiner",
    "said": "One correction: those two gyros are vacuum-driven, so there's no breaker to pull for them. Placarding them inoperative is the main thing. Now, beyond \"not required\" and \"placarded,\" there's one more judgment the rule asks for before you go. What is it, and who is allowed to make that call?",
    "turn": 16
  },
  {
    "who": "applicant",
    "said": "The rule also requires that I, as pilot in command, make a determination that the aircraft is still safe to operate with those instruments inoperative. 14 CFR 91.213(d) says I have to decide whether the inoperative equipment doesn't constitute a hazard to the aircraft—and only the PIC can make that call before flight.",
    "turn": 16
  },
  {
    "who": "examiner",
    "said": "\"Only the PIC\" isn't what the rule says. The PIC isn't the only person who can make that hazard call. Who else does 91.213(d) let make it? Tell me which certificates qualify.",
    "turn": 17
  },
  {
    "who": "applicant",
    "said": "I need to narrow this down—are you asking me which certificated persons can make that hazard determination in general under the rule, or are you asking specifically who *I* can delegate it to before I fly today?",
    "turn": 17
  },
  {
    "who": "examiner",
    "said": "In general, under the rule. Who, by certificate, is allowed to decide the inoperative item isn't a hazard?",
    "turn": 18
  },
  {
    "who": "applicant",
    "said": "Under 14 CFR 91.213(d), the pilot in command, an aircraft mechanic, or an authorized inspector—such as an A&P mechanic or an IA—can make the determination that inoperative equipment doesn't constitute a hazard to the aircraft.",
    "turn": 18
  },
  {
    "who": "examiner",
    "said": "Good. Change the failure. This time the vacuum pump is fine, but the oil pressure gauge on N5124K reads zero, and you've confirmed the gauge itself is broken. The engine is fine. Can you placard it and go to Easton? Why or why not?",
    "turn": 19
  },
  {
    "who": "applicant",
    "said": "No, I cannot. The oil pressure gauge is required equipment under 14 CFR Part 23, and even though I've confirmed the engine is actually fine, I don't have the authority under 91.213(d) to make that determination myself—only a mechanic or IA can certify the gauge failure doesn't constitute a hazard.",
    "turn": 19
  },
  {
    "who": "examiner",
    "said": "Your conclusion is right, but your reason isn't. A mechanic can't sign away a required instrument any more than you can. Placarding doesn't apply to required equipment at all. So tell me: where do you look to find out whether an item is required, and what does it mean for the airplane's status, and for today's flight, when a required item is broken?",
    "turn": 20
  },
  {
    "who": "applicant",
    "said": "You look in Part 23 of the CFR or the aircraft's type certificate to find what equipment is required. When a required item is broken, the aircraft is unairworthy and cannot be operated—I cannot legally fly N5124K to Easton today with a failed oil pressure gauge, even though the engine itself is fine.",
    "turn": 20
  },
  {
    "who": "examiner",
    "said": "It's a pilot's job to look first at 91.205 and the airplane's equipment list, not Part 23, but your conclusion stands. Now, look in N5124K before we board. There are two certificates issued to this airplane that must be on board. Name them, and tell me how each has to be carried or displayed.",
    "turn": 21
  },
  {
    "who": "applicant",
    "said": "The two certificates are the Airworthiness Certificate and the Registration Certificate. The Airworthiness Certificate must be displayed in the aircraft, and the Registration Certificate must be carried on board—I have both here in my preflight packet, and I verified the Registration is on board during my walk-around.",
    "turn": 21
  },
  {
    "who": "examiner",
    "said": "You said it's in your preflight packet. Is that good enough for the first one you named? Where exactly in the airplane does it have to be, and who has to be able to read it?",
    "turn": 22
  },
  {
    "who": "applicant",
    "said": "No, I misspoke—the Airworthiness Certificate has to be displayed in the aircraft itself, visible to passengers. It's not enough to have it in my packet. It needs to be posted where anyone can read it, typically on or near the instrument panel or cabin door.",
    "turn": 22
  },
  {
    "who": "examiner",
    "said": "Let's look at the weather. You've got 5 miles and an 1,800-foot overcast. You'll cruise mostly in Class E between Gaithersburg and Easton. What are the visibility and cloud-clearance minimums there, and where do you have to fly to meet them today?",
    "turn": 23
  },
  {
    "who": "applicant",
    "said": "I want to make sure I'm reading this right—are you asking me about the general VFR minimums for Class E airspace, or are you asking specifically where on my route today I'd be flying in Class E and what I need to do there?",
    "turn": 23
  },
  {
    "who": "examiner",
    "said": "Start with the general rule. In Class E below 10,000 feet, what visibility do you need, and how far do you have to stay from clouds? Then we'll put it on today's 1,800-foot overcast.",
    "turn": 24
  },
  {
    "who": "applicant",
    "said": "In Class E airspace below 10,000 feet, VFR minimums are 3 statute miles visibility and 500 feet below, 1,000 feet above, and 2,000 feet horizontal distance from clouds.",
    "turn": 24
  },
  {
    "who": "examiner",
    "said": "Take those Class E numbers and put them on today. The overcast is at 1,800 feet AGL and visibility is 5 miles. What's the highest altitude you can legally cruise at in Class E between Gaithersburg and Easton, and why?",
    "turn": 25
  },
  {
    "who": "applicant",
    "said": "I can cruise at 1,300 feet MSL maximum in Class E today. The ceiling is 1,800 feet AGL, and I need to stay 500 feet below the clouds to meet the Class E requirement, so 1,800 minus 500 equals 1,300 feet MSL.",
    "turn": 25
  },
  {
    "who": "examiner",
    "said": "Careful: the ceiling is reported AGL, so 1,300 is AGL, not MSL. Add field elevation to get MSL. Now give me the full Class E cloud clearance again: below, above, and horizontal, plus the visibility. And which other classes of airspace use those same numbers below 10,000?",
    "turn": 26
  },
  {
    "who": "applicant",
    "said": "In Class E below 10,000 feet, the minimums are 3 statute miles visibility, 500 feet below clouds, 1,000 feet above, and 2,000 feet horizontal. Those same numbers apply to Class G airspace above 1,200 feet AGL during the day.",
    "turn": 26
  },
  {
    "who": "examiner",
    "said": "Close, but not quite. Class G above 1,200 AGL by day uses the same cloud clearances, but its visibility requirement is lower. I'm asking about controlled airspace. Easton has a tower. Besides Class E, which other controlled airspace classes use exactly those Class E numbers below 10,000 feet?",
    "turn": 27
  },
  {
    "who": "applicant",
    "said": "Are you asking which controlled airspace classes use those same minimums—3 statute miles visibility, 500 below, 1,000 above, 2,000 horizontal—or are you asking specifically about the airspace I'll be flying through on today's route?",
    "turn": 27
  },
  {
    "who": "examiner",
    "said": "The general one. Which airspace classes share those exact numbers?",
    "turn": 28
  },
  {
    "who": "applicant",
    "said": "Class D and Class C both use those same minimums below 10,000 feet: 3 statute miles visibility, 500 feet below, 1,000 feet above, and 2,000 feet horizontal.",
    "turn": 28
  },
  {
    "who": "examiner",
    "said": "That's right, C and D. Now suppose the clouds drop you low, and you end up in Class G airspace, under 1,200 feet AGL over the Eastern Shore in daytime. What visibility and cloud clearance do you need down there?",
    "turn": 29
  },
  {
    "who": "applicant",
    "said": "In Class G airspace below 1,200 feet AGL during the day, I need 1 statute mile visibility and clear of clouds—so I have to stay out of the clouds entirely.",
    "turn": 29
  },
  {
    "who": "examiner",
    "said": "Your plan says cruise at 3,500 MSL. You just told me the overcast is 1,800 AGL. Walk me through why you picked 3,500, and whether it still works today.",
    "turn": 30
  },
  {
    "who": "applicant",
    "said": "Good question. Let me walk through my thinking. First, I computed my terrain: I'm crossing from the Piedmont near Montgomery County up to 539 feet, then down to the coastal plain and Chesapeake Bay crossing, landing at Easton at 72 feet. The highest terrain I'll encounter en route is probably around 300 to 400 feet, so 3,500 MSL gives me roughly 3,000 feet of clearance above ground, which is well above the 1,000-foot minimum for cruising in Class E. Second, I needed to stay below the DC SFRA floor — the SFRA is SFC to FL180, so 3,500 is comfortably below that, and I'm in Class E most of the way until I descend into Class D at Annapolis. Third, I checked winds aloft: 3,000 feet shows 0915, and 6,000 shows 0920 plus 2, so 3,500 is a reasonable compromise for a 64-nautical-mile flight where I don't want to climb too high and burn extra fuel.",
    "turn": 30
  },
  {
    "who": "examiner",
    "said": "Two problems. The SFRA goes from the surface to FL180, so at 3,500 you're inside it, not under it. And you never mentioned the 1,800-foot overcast. Leave the clouds aside for a moment. On a good day, what would 3,500 buy you over the Chesapeake, and how does it fit the cruising-altitude rule for a 125-degree course?",
    "turn": 31
  },
  {
    "who": "applicant",
    "said": "On a good day, 3,500 gives me about 3,400 feet above the water, which is solid margin for an engine-out glide to shore. For the cruising rule — I'm flying a magnetic course of 125 degrees, which is southeast, so I'm supposed to cruise at an odd thousand plus 500, meaning 3,500 or 5,500.",
    "turn": 31
  },
  {
    "who": "examiner",
    "said": "Right, but 3,500 doesn't fit under an 1,800-foot overcast. Today you'll be well below it, over the bay with much less glide margin, and conditions are marginal. You've listed KANK, KCGE and KSBY as alternates. Walk me through each one: why it's on the list, where it sits relative to your route, and when you'd turn for it.",
    "turn": 32
  },
  {
    "who": "applicant",
    "said": "Before I answer, I need to clarify what you're asking. When you say 'when you'd turn for it,' do you mean under what specific condition — like if I lose an engine, or if the weather deteriorates below minimums at my destination, or if I get a TFR closure along my route? Because that changes which alternate I'd pick and when I'd commit to it. Also, I should say I have the chart here in front of me, but I want to make sure I'm looking at the right thing: are you asking me to justify why each one qualifies as a legal alternate — meaning it meets fuel and weather minimums — or are you asking me to walk through my decision logic in the air if things go wrong? Those aren't the same thing.",
    "turn": 32
  },
  {
    "who": "examiner",
    "said": "Your decision-making in the air. Picture the weather getting worse: the ceiling lowering over the bay, or Easton going below VFR before you get there. Which of those three airports do you go to in each case, and what makes each one a good place to land? Think about runways, fuel, services and approaches.",
    "turn": 33
  },
  {
    "who": "applicant",
    "said": "Okay, got it. Let me walk through this with the chart. KANK is about 15 miles south of my route and has a 5,000-foot runway, so if the ceiling drops over the bay I can divert there early. KCGE is further south, almost at my destination, so I'd use that if I'm committed to pushing past the bay but need to bail before Easton.",
    "turn": 33
  },
  {
    "who": "examiner",
    "said": "You skipped Salisbury. Say you're past the bay and Easton reports 800 overcast. Where do you go, and what about that airport makes it the right choice in today's marginal weather? Think about fuel, services, and what happens if it closes in there too.",
    "turn": 34
  },
  {
    "who": "applicant",
    "said": "I need to clarify something—when you say 'Salisbury,' are you referring to KSBY, which I do have listed as my third alternate? And when you ask what I'd do if Easton reports 800 overcast, I'm assuming you mean I'm already committed past the bay with limited fuel to turn back—so KSBY is my last-resort alternate if I can't get into Easton.",
    "turn": 34
  },
  {
    "who": "examiner",
    "said": "Yes, KSBY. And you're not short on fuel. Your plan shows plenty on board. So tell me why you'd pick Salisbury specifically, and what about it you checked before we left today.",
    "turn": 35
  },
  {
    "who": "applicant",
    "said": "KSBY is my third alternate on the chart here—it's got a 5,000-foot runway and good services if I need to land. Before we left I checked the field elevation, runway length, and made sure it was on my sectional so I could navigate to it if needed.",
    "turn": 35
  },
  {
    "who": "examiner",
    "said": "Runway and services are good. But a VFR pilot isn't required to file an alternate. So why did you bother with three on this particular flight? What about today's weather, and about Easton, made you want somewhere else lined up?",
    "turn": 36
  },
  {
    "who": "applicant",
    "said": "Today's forecast shows marginal VFR with 1800-foot ceiling and 5-mile visibility, plus icing risk and fog risk—that's unstable enough that I wanted alternates I could actually reach if Easton went below minimums or closed.",
    "turn": 36
  },
  {
    "who": "examiner",
    "said": "Let's work the numbers. Your course is 125 magnetic and you've got 64 miles. Use the 3,000-foot wind on your sheet, 090 at 15. Roughly what groundspeed will you see, and how long will the leg take?",
    "turn": 37
  },
  {
    "who": "applicant",
    "said": "I want to make sure I'm reading this right—the winds aloft on my sheet show 0915 at 3,000 feet, which is 090 at 15 knots. But my cruise altitude is 3,500 feet. Should I use the 3,000-foot winds you just gave me, or should I interpolate between the 3,000 and 6,000-foot winds on my actual flight plan?",
    "turn": 37
  },
  {
    "who": "examiner",
    "said": "Use the 3,000-foot wind. Given the ceiling, that's closer to where you'll really be anyway. Say you're cruising around 110 knots. Talk me through how you get from that and the wind to a groundspeed, a heading, and a time for the 64 miles.",
    "turn": 38
  },
  {
    "who": "applicant",
    "said": "Roger, I'll work through this step by step. I've got a true airspeed of about 110 knots and a magnetic course of 125 degrees. The wind is 090 at 15 knots, which means it's coming from the northeast. First, I need to find my heading correction—the wind is roughly a 35-degree angle off my course, so I'll get some drift correction; I'd estimate I need to crab maybe 8 to 10 degrees into the wind, putting my heading around 133 to 135 magnetic. For groundspeed, the wind has a component along my course—since it's from the northeast and I'm going southeast, I'm getting a slight headwind component, probably losing 3 to 4 knots, so I'm looking at a groundspeed around 106 to 107 knots. With 64 nautical miles to Easton and a groundspeed of roughly 107 knots, that works out to about 36 minutes for the flight—a hair under 0.6 hours, which matches my filed flight time.",
    "turn": 38
  },
  {
    "who": "examiner",
    "said": "Your method is fine, but check your numbers. A wind from 090 on a 125 course is off your left nose, so you crab left, toward roughly 120, not 135. The headwind component is closer to 12 knots, so expect about 98 knots over the ground and nearer 39 minutes. And remember that forecast winds aloft are given in true degrees.",
    "turn": 39
  },
  {
    "who": "examiner",
    "said": "Now let's fly the route. Start at Gaithersburg and go out past Columbia, Annapolis and Kent Island to Easton. What class of airspace are you in at each stage?",
    "turn": 40
  },
  {
    "who": "applicant",
    "said": "Got it—thank you for the correction. I see my error: the wind is from the northeast, which is ahead and to my left on a southeast course, so I crab left toward 120, not right. And I missed that winds aloft are true, not magnetic, so I need to convert before applying the correction.",
    "turn": 40
  },
  {
    "who": "examiner",
    "said": "Good. Now the airspace question. Start on the runway at Gaithersburg. What class of airspace is that? Then go leg by leg until you're landing at Easton.",
    "turn": 41
  },
  {
    "who": "applicant",
    "said": "At Gaithersburg, KGAI, we're in Class E airspace. Then heading southeast, I'm in the DC SFRA out to about 30 miles—that's where I need squawk 1226 and radio contact with Potomac. Past Columbia I enter Class B Baltimore, which I need to avoid or get clearance through. Around Annapolis I'm in Class D Naval Academy airspace.",
    "turn": 41
  },
  {
    "who": "examiner",
    "said": "Check Gaithersburg again. It's a non-towered field. Look at the sectional symbol: is there anything that makes the surface there controlled, or is it something else? Then finish the trip. What are you in for the open cruise portion over the bay, and what's waiting at Easton, which has a tower?",
    "turn": 42
  },
  {
    "who": "applicant",
    "said": "You're right—I need to look at the symbol more carefully. KGAI is non-towered, so the surface is Class G, not Class E. Then once I'm airborne and in the SFRA I transition to Class E, and I need that squawk and Potomac contact. Over the open water past Kent Island I'm back in Class G until I approach Easton, which is Class D because it has a tower.",
    "turn": 42
  },
  {
    "who": "examiner",
    "said": "One correction before we move on. Over the bay at cruise you're in Class E, not G. The Class G there only runs up from the surface to the Class E floor.",
    "turn": 43
  },
  {
    "who": "examiner",
    "said": "Given that route, the SFRA, the Baltimore Bravo nearby, and Easton's tower, what does N5124K need installed and working to fly it legally today?",
    "turn": 44
  },
  {
    "who": "applicant",
    "said": "Got it—thank you. So once I'm at 3,500 feet over the bay, I'm in Class E airspace. The Class G only exists below that floor up from the surface. I'll make sure I have that clear for the actual flight.",
    "turn": 44
  },
  {
    "who": "examiner",
    "said": "Right. Now my question: what equipment does the airplane need to have working for the airspace you'll be in today? Think about what lets ATC see you.",
    "turn": 45
  },
  {
    "who": "applicant",
    "said": "Okay, so the SFRA requires Mode C transponder for ATC radar, and I need a working radio for two-way communication with Potomac Approach. For the Class D at Easton, I also need the radio. Looking at my panel, I have both—transponder was checked in March and the radio is functional. Those two are what let ATC see and talk to me.",
    "turn": 45
  },
  {
    "who": "examiner",
    "said": "You'll pass inside the Baltimore 30-mile veil. Since 2020 there's been a second piece of surveillance equipment required wherever a Mode C transponder is required. What is it?",
    "turn": 46
  },
  {
    "who": "applicant",
    "said": "I want to make sure I'm understanding you correctly—are you asking about equipment that's required to be installed and working on the aircraft, or are you asking about something the pilot needs to have completed or certified? Because I know Mode C requires ADS-B Out in that airspace, but I want to be sure that's what you're asking about.",
    "turn": 46
  },
  {
    "who": "examiner",
    "said": "Yes, ADS-B Out. Now, your sheet flags the DC SFRA and TFR awareness near Annapolis. It's 1430 departure. How and when do you check for TFRs on this route, and what do you do if one pops up after you're airborne?",
    "turn": 47
  },
  {
    "who": "applicant",
    "said": "I check tfr.faa.gov before I leave the house and again right before engine start—that's my pre-flight. If a TFR pops up after I'm airborne, I need to leave it immediately or request a clearance through the controlling agency, and I'd contact ATC or Potomac Approach to let them know I'm deviating.",
    "turn": 47
  },
  {
    "who": "examiner",
    "said": "The TFR website is a convenience. What's the official way a TFR is published, the one you'd be held to, and how does it show up in your standard briefing?",
    "turn": 48
  },
  {
    "who": "applicant",
    "said": "TFRs are officially published in the NOTAM system, and they'll come up in my standard briefing when I file my flight plan through 1800wxbrief or call FSS. That's the official notice I'm held to as the PIC.",
    "turn": 48
  },
  {
    "who": "examiner",
    "said": "Say Potomac clears you through the Baltimore Bravo to stay out of the clouds. Once you're inside Class B, what visibility and cloud clearance do you need?",
    "turn": 49
  },
  {
    "who": "applicant",
    "said": "I need to clarify—are you asking what the rule requires inside Class B airspace in general, or are you asking what I need given that I'm VFR and the forecast shows 5 statute miles visibility with an 1800-foot ceiling? Those give different answers.",
    "turn": 49
  },
  {
    "who": "examiner",
    "said": "The rule itself. What visibility and cloud clearance does the regulation require inside Class B, and how is that different from the Class E numbers you gave me earlier?",
    "turn": 50
  },
  {
    "who": "applicant",
    "said": "Inside Class B, the rule requires 3 statute miles visibility and clear of clouds—that's 1000 feet below, 1000 feet above, and 2000 feet horizontally. In Class E during the day, it's 3 statute miles visibility and 500 feet below, 1000 feet above, and 2000 feet horizontal.",
    "turn": 50
  },
  {
    "who": "examiner",
    "said": "You said \"clear of clouds\" and then gave me distances. Those don't go together. \"Clear of clouds\" in Class B doesn't come with any distances. So what exactly does it mean, how close to a cloud could you legally be in the Bravo, and how is that different from Class E?",
    "turn": 51
  },
  {
    "who": "applicant",
    "said": "You're right, I misspoke. In Class B, 'clear of clouds' means you have to stay out of cloud, period—zero distance tolerance, you can't be in it. In Class E during the day, 'clear of clouds' also means you stay out of the cloud itself, but you only need 500 feet below and 1000 feet above.",
    "turn": 51
  },
  {
    "who": "examiner",
    "said": "Not quite. Class E isn't a \"clear of clouds\" rule at all. It's a distance rule, and you left out a number. So set them side by side for me: Bravo is clear of clouds, and what is the full distance rule that applies in C, D and E instead?",
    "turn": 52
  },
  {
    "who": "applicant",
    "said": "You're right, I need to be more careful here. Are you asking me to state the distance rule that applies in Class C, D, and E all together as one rule, or are you asking me to distinguish between what's required in each of those three airspaces separately?",
    "turn": 52
  },
  {
    "who": "examiner",
    "said": "As one rule. They share it. Give me the cloud distances, all three, and contrast them with Bravo.",
    "turn": 53
  },
  {
    "who": "applicant",
    "said": "Class B is clear of clouds—no distance allowed. In Class C, D, and E, the rule is 500 feet below, 1000 feet above, and 2000 feet horizontal from the cloud.",
    "turn": 53
  },
  {
    "who": "examiner",
    "said": "Your weight and balance sheet is in front of you. You, two friends in back, full tanks, 45 pounds of bags. Walk me through how you got your total weight and CG. What's the method, and where does each number come from?",
    "turn": 54
  },
  {
    "who": "applicant",
    "said": "I'll walk you through my W&B calculation step by step. First, I started with the empty aircraft weight and arm from the aircraft specs—that's 1663 pounds at an arm of 38.1 inches. Then I added myself as pilot in the front left seat at 175 pounds with an arm of 37.0 inches. I have two friends in back totaling 320 pounds at an arm of 73.0 inches, which I got from their actual weights. Full fuel is 53 usable gallons, which at 6 pounds per gallon gives me 318 pounds at the fuel arm of 48.0 inches. Then the baggage—45 pounds at 95.0 inches back at the aft limit. I summed all the weights to get 2521 pounds total, which is 29 pounds under my max gross of 2550 pounds, so I'm good there. For CG, I calculated the moment for each item—weight times arm—then divided the total moment by total weight to get 44.7 inches. That's right in my envelope of 35.0 to 47.",
    "turn": 54
  },
  {
    "who": "examiner",
    "said": "The math checks out. You keep using the word \"arm.\" Seventy-three inches from what, exactly? What is an arm measured from?",
    "turn": 55
  },
  {
    "who": "applicant",
    "said": "An arm is the distance measured from the datum—that's the reference point on the aircraft, usually somewhere near the nose or firewall. The datum is zero, and all arms are measured as horizontal distances aft from that point in inches.",
    "turn": 55
  },
  {
    "who": "examiner",
    "said": "Good. Now the runway. You're 29 pounds under gross out of Gaithersburg. Walk me through how you got the takeoff and landing distances on your sheet: which chart, which inputs, and what you'd do with the numbers it gave you.",
    "turn": 56
  },
  {
    "who": "applicant",
    "said": "I used the Cessna 172S Pilot's Operating Handbook Section 5 for both takeoff and landing performance. For takeoff, I entered my pressure altitude of 539 feet at departure, the outside air temperature of 4 degrees Celsius from the forecast, my total weight of 2521 pounds, and the 5-knot headwind I calculated from the active runway 14 and the surface wind. I used the short-field flaps 10 chart because runway 14 at Gaithersburg is 3200 feet, and that's my most conservative scenario. That gave me a ground roll of 866 feet and total distance over a 50-foot obstacle of 1474 feet—well within the available runway, so I'm legal for takeoff. For landing, I used the same section but the short-field full-flap chart at my expected landing weight of 2490 pounds, pressure altitude 72 feet at Easton, 4 degrees again, and a 5-knot headwind on runway 22.",
    "turn": 56
  },
  {
    "who": "examiner",
    "said": "You're 29 pounds under gross with the CG at 44.7. Say one of your friends shows up with a 40-pound cooler she wants to throw in baggage. What happens to your numbers, and what does that mean for whether you can legally go?",
    "turn": 57
  },
  {
    "who": "applicant",
    "said": "If I add 40 pounds to baggage, my total weight goes to 2561 pounds, which is 11 pounds over the 2550-pound gross weight limit—so I'd be illegal to fly. I'd have to either leave the cooler behind or offload 40 pounds of fuel, which would cut into my reserve and likely make me unable to reach my destination and alternate safely.",
    "turn": 57
  },
  {
    "who": "examiner",
    "said": "Check that fuel claim. Forty pounds is under 7 gallons, and your plan shows about 42 gallons left at Easton, so offloading fuel is a perfectly good option. Now, that 2,550 number, and limits like it: where do they legally come from, and where in N5124K would you find them?",
    "turn": 58
  },
  {
    "who": "applicant",
    "said": "The maximum gross weight limit comes from the aircraft's type certification and is published in the Cessna 172S Pilot's Operating Handbook, which I have on board. I'd find the specific number of 2550 pounds listed in the aircraft limitations section of the POH, and it's also on the data plate attached to the aircraft itself.",
    "turn": 58
  },
  {
    "who": "examiner",
    "said": "A small point: the data plate doesn't list gross weight. The POH limitations section and the placards do. Now, your CG is 44.7, and the aft limit is 47.3. All the extra weight goes behind the seats. If you loaded it wrong and ended up past that aft limit, how would the airplane behave?",
    "turn": 59
  },
  {
    "who": "applicant",
    "said": "The airplane would become tail-heavy and harder to control. It could pitch up more easily, reduce elevator authority, and in a severe case make it difficult or impossible to recover from a stall or steep descent—which is why the CG envelope exists.",
    "turn": 59
  },
  {
    "who": "examiner",
    "said": "Think about what you'd feel in the yoke. Compared with a normal load, how heavy or light would the pitch control be with an aft CG, and why does that matter in the flare at Easton?",
    "turn": 60
  },
  {
    "who": "applicant",
    "said": "With an aft CG, the pitch control would feel lighter—less force needed to pull back on the yoke. That matters in the flare at Easton because I might accidentally over-control and pitch up too steeply, ballooning the airplane or stalling it during landing when I need precise, stable control.",
    "turn": 60
  },
  {
    "who": "examiner",
    "said": "Decision time. An 1,800-foot overcast, 5 miles, a 2-degree temperature–dewpoint spread at 4 Celsius, icing and fog both flagged, a bay crossing, and two passengers. It's legal. Are we going? Tell me what in that weather drives your answer.",
    "turn": 61
  },
  {
    "who": "applicant",
    "said": "No, we're not going. The 2-degree spread at 4°C means we're right at the threshold for visible moisture and icing—that's the critical concern. Add the 1,800-foot ceiling and 5-mile visibility over a 55-nautical-mile bay crossing, and if we pick up ice or lose visibility, we have no altitude buffer and no good way out.",
    "turn": 61
  },
  {
    "who": "examiner",
    "said": "The bay crossing is only a few miles of your 64, not 55, but your point stands. You've judged the conditions as they are right now. What is that 2-degree spread telling you about where the weather is heading this afternoon? And besides cancelling outright, what else could you do?",
    "turn": 62
  },
  {
    "who": "applicant",
    "said": "A 2-degree spread that tight means we're already producing moisture—we could see fog form or thicken as the afternoon goes on, especially over the water where it's cooler. Instead of cancelling outright, I could delay departure a few hours to see if the temperature warms up, which would open that spread and reduce icing and fog risk, or I could fil",
    "turn": 62
  },
  {
    "who": "examiner",
    "said": "One more thing. The Easton TAF has a TEMPO group, 3 miles in mist with an overcast at 1,500, and it covers the middle of our flight. Your two friends are in the lobby with their bags packed, waiting on you. Walk me through how you actually make the call, and what you tell them.",
    "turn": 64
  },
  {
    "who": "applicant",
    "said": "Okay, so the TAF TEMPO drops us to 1,500 feet overcast and 3 miles in mist right when we'd be crossing the bay and descending into Easton—that's worse than forecast and it overlaps with the part of the flight where we have the least options. Here's what I do: I pull up the latest METARs for Easton and any stations between here and there to see if that TEMPO is already happening or if it's predicted to start later. Then I check the current radar and satellite to see if there's actually moisture building over the bay, or if this is just a conservative forecast. If the TEMPO is imminent or already showing up in real weather, we don't go—1,500 feet and 3 miles over water with a bay between us and any meaningful divert is below my comfort level and probably below what's safe for the flight.",
    "turn": 64
  },
  {
    "who": "examiner",
    "said": "You said \"below my comfort level.\" At 55 hours, what exactly is that level? Did you set numbers before today, and what are they? And is there a structured checklist you run instead of going on gut feel?",
    "turn": 65
  },
  {
    "who": "applicant",
    "said": "Yes, I set minimums before today—I won't fly below 1,000 feet AGL ceiling and 5 miles visibility in VFR conditions, and I always maintain 500 feet AGL and 1 mile visibility as an absolute floor before I turn back. I use the personal minimums checklist from my flight school, not gut feel—it's on my kneeboard right now.",
    "turn": 65
  },
  {
    "who": "examiner",
    "said": "Notice your own numbers: 5 miles is your minimum, and the TEMPO's 3 miles is below it. Now run the four-part risk framework on this flight. Give me one real risk from today in each category, starting with you as the pilot and ending with your friends waiting in the lobby.",
    "turn": 66
  },
  {
    "who": "applicant",
    "said": "I want to make sure I'm understanding the four categories correctly—are you asking me to frame this as pilot, aircraft, environment, and external pressures? Or is there a specific risk framework you're referring to that I should be using?",
    "turn": 66
  },
  {
    "who": "examiner",
    "said": "Yes, those four. Go through them one at a time, each tied to something real about today.",
    "turn": 67
  },
  {
    "who": "applicant",
    "said": "Okay. Pilot: I have only 12 hours PIC and no flight review yet, so my experience is below what I'd want for MVFR and icing risk. Aircraft: the annual inspection expires in about five months, and I'm already at gross weight with rear passengers, so I have no margin for error.",
    "turn": 67
  },
  {
    "who": "examiner",
    "said": "Check the date on that annual: May 12th of last year. That's not five months away, it runs out at the end of next month. It's legal today, but it's close. Now finish the other two: environment, and the external pressures. What are they today?",
    "turn": 68
  },
  {
    "who": "applicant",
    "said": "Environment: we're looking at MVFR with icing risk and a 2-degree spread, so fog is real and carburetor ice is a genuine threat at 3,500 feet. External pressures: I have friends and family waiting at Easton, which makes me want to press on if conditions get marginal, and I know my experience is limited, so I need to be honest about turning back if",
    "turn": 68
  },
  {
    "who": "examiner",
    "said": "One thing: N5124K has a fuel-injected IO-360, so there's no carburetor to ice. Airframe ice is the threat. And your external pressure isn't only at Easton. Who's sitting in this lobby right now with their bags, and how does that push on you? Last, what's the four-letter name of the checklist you just ran?",
    "turn": 69
  },
  {
    "who": "applicant",
    "said": "You're right—airframe ice is the real threat at this altitude with that spread. My rear passengers are here waiting, and that's pressure I need to recognize and not let drive the decision.",
    "turn": 69
  },
  {
    "who": "examiner",
    "said": "And the name of that four-part checklist?",
    "turn": 70
  },
  {
    "who": "applicant",
    "said": "The preflight checklist—it's the AROW check: airworthiness certificate, registration, operating handbook, and weight and balance. Actually, wait—I'm not sure if you're asking me to name the formal checklist I just ran through, or if you mean something else. Can you clarify what you're looking for?",
    "turn": 70
  },
  {
    "who": "examiner",
    "said": "That's ARROW, a documents check. What I was after was PAVE: pilot, aircraft, environment, external pressures. All right, let's get in the airplane.",
    "turn": 71
  },
  {
    "who": "examiner",
    "said": "You mentioned carb ice earlier. Look around this panel and tell me how fuel actually gets mixed with air in this engine, and what that means for the carb-heat knob you'd find on an older 172.",
    "turn": 72
  },
  {
    "who": "applicant",
    "said": "Got it—PAVE. Pilot, aircraft, environment, external pressures. I see it now. I'm ready to go through the startup checklist when you are.",
    "turn": 72
  },
  {
    "who": "examiner",
    "said": "Before we start, one question about this engine. Older 172s have a carb-heat knob. Where is it on this panel? If it isn't there, why not, and what protects the induction if it ices up or gets blocked?",
    "turn": 73
  },
  {
    "who": "applicant",
    "said": "This is a 172S with a fuel-injected Lycoming IO-360, so there's no carburetor and no carb-heat knob on the panel. The fuel injection system doesn't have the same icing risk as a carb. We do have an alternate air source for the engine induction in case the main air filter gets blocked, but that's different from carb heat.",
    "turn": 73
  },
  {
    "who": "examiner",
    "said": "Good. Now point to the gyroscopic instruments on this panel. Tell me what each one does, and what drives it.",
    "turn": 74
  },
  {
    "who": "applicant",
    "said": "The attitude indicator, heading indicator, and turn coordinator are the gyroscopic instruments. The attitude indicator shows pitch and bank; the heading indicator shows magnetic heading; the turn coordinator shows rate and direction of turn.",
    "turn": 74
  },
  {
    "who": "examiner",
    "said": "Fine on what they show. But what's physically inside each case that lets it sense attitude or turn? And earlier the vacuum pump died. Which of these three would still be working, and why?",
    "turn": 75
  },
  {
    "who": "applicant",
    "said": "I need to clarify — when you say 'the vacuum pump died,' do you mean it failed during flight today, or are you asking me a general question about which instruments would fail if the vacuum pump quit? That changes which instruments I'd be talking about.",
    "turn": 75
  },
  {
    "who": "examiner",
    "said": "Forget the vacuum pump for now. Just this: what's spinning inside each of those three instruments, and why does it need to spin to work?",
    "turn": 76
  },
  {
    "who": "applicant",
    "said": "Each one has a spinning rotor inside, gyroscope-style. The rotor spins really fast—vacuum pump pulls air through to make it spin for the attitude and heading indicators. The turn coordinator uses an electric motor instead.",
    "turn": 76
  },
  {
    "who": "examiner",
    "said": "We're over the bay, twenty minutes out. You tune in Easton's ASOS: three miles in mist, overcast at nine hundred. Your friends in back are talking about dinner in Easton. What's going on in your head right now that could get us in trouble, and what are you doing about it?",
    "turn": 78
  },
  {
    "who": "applicant",
    "said": "I'm noticing the ceiling dropped to nine hundred feet AGL, which is below my cruise altitude of thirty-five hundred feet MSL, and visibility is down to three miles in mist—that's below VFR minimums.",
    "turn": 78
  },
  {
    "who": "examiner",
    "said": "Small correction: three miles meets the Class D visibility minimum. It's the 900-foot ceiling that puts Easton below VFR. But I asked about you, not the weather. You're 20 minutes from dinner, with friends aboard. What's the pull you're feeling, what's it called, and what do you actually do with the airplane?",
    "turn": 79
  },
  {
    "who": "applicant",
    "said": "That's get-there-itis—I want to land there because my friends are expecting dinner and we're close. But I'm not landing in 900-foot overcast; that's instrument conditions. I'm diverting to one of my alternates—Annapolis or Cambridge—where the weather is VFR, and letting them know what's happening.",
    "turn": 79
  },
  {
    "who": "examiner",
    "said": "Good call. Get-there-itis isn't one of the five hazardous attitudes on its own. Which of the five does it grow out of? And with 55 hours, how do the limits you set on the ground fit into that decision when your friends are leaning on you?",
    "turn": 80
  },
  {
    "who": "applicant",
    "said": "Get-there-itis comes from invulnerability—I think I can handle it when I really can't. With 55 hours and only 12 PIC, I set my limits on the ground for a reason: I'm not instrument-rated, I can't land in 900 feet, and that doesn't change because my friends want dinner. I stick to what I planned and briefed, not what feels urgent in the moment.",
    "turn": 80
  },
  {
    "who": "examiner",
    "said": "You said a go decision back at the FBO. Now you're diverting. Was the original go wrong, or is this how it's supposed to work? Tell me how that decision should be handled from engine start to shutdown.",
    "turn": 81
  },
  {
    "who": "applicant",
    "said": "I need to clarify what you're asking—do you mean how I should have monitored the weather continuously from preflight through engine start to catch the change, or are you asking about the decision-making process itself once I'm airborne and see the ceiling is actually lower than forecast? Those are different timelines.",
    "turn": 81
  },
  {
    "who": "examiner",
    "said": "One note on the attitude you named: the one you picked is about thinking accidents happen to other people. Pushing on to get there usually comes from a different one. Look it up tonight. On my question, I mean the decision-making itself. Is go/no-go one decision you make on the ground, or something else? How does it work once you're airborne?",
    "turn": 82
  },
  {
    "who": "applicant",
    "said": "You're right, I'll review that tonight. On the decision-making: go/no-go isn't just a one-time call on the ground—it's continuous. I make the initial decision at preflight with the best information I have, but I'm constantly reassessing in flight.",
    "turn": 82
  },
  {
    "who": "examiner",
    "said": "\"Constantly reassessing\" is easy to say. Make it concrete for this flight. What, specifically, should trigger you to rerun the decision between Gaithersburg and Easton, and what did that look like when the ASOS came in?",
    "turn": 83
  },
  {
    "who": "applicant",
    "said": "My triggers should be any significant change from what I briefed—ceiling, visibility, wind, or icing conditions getting worse than forecast. When I got the ASOS just before engine start, the ceiling was 1,800 feet and visibility 5 SM, which matched the forecast MVFR, so my go decision still held.",
    "turn": 83
  },
  {
    "who": "examiner",
    "said": "Another one. The low-voltage light came on about a minute ago, and the ammeter shows a discharge. You're still over the bay. You're on battery now. What do you turn off, what do you keep, and why?",
    "turn": 85
  },
  {
    "who": "applicant",
    "said": "I need to clarify—when you say 'what do you turn off,' do you mean what avionics and systems, or are you asking about the order and logic of what stays powered for the rest of the flight? I want to make sure I'm thinking about this the right way before I answer.",
    "turn": 85
  },
  {
    "who": "examiner",
    "said": "The logic. You have a battery that will only last so long, and a towered airport to get into. Name the specific things you'd switch off, the things you'd keep on, and why.",
    "turn": 86
  },
  {
    "who": "applicant",
    "said": "I'd keep the radio, engine instruments, and lights on—those are essential to land safely and talk to the tower. I'd turn off the autopilot, transponder, and any unnecessary avionics to stretch the battery.",
    "turn": 86
  },
  {
    "who": "examiner",
    "said": "Think about the transponder. You're inside the Baltimore veil and close to the SFRA, in poor visibility. What happens to you on ATC's radar if you switch it off, and what does the airspace require?",
    "turn": 87
  },
  {
    "who": "applicant",
    "said": "You're right—I need to keep the transponder on. We're in Class B airspace and the SFRA, both of which require Mode C transponder. If I squawk off, ATC loses my altitude readout and I become a primary target only. That's a violation, and more importantly, they can't see me vertically anymore—which is dangerous in this traffic and low visibility.",
    "turn": 87
  },
  {
    "who": "examiner",
    "said": "Good. Now a different direction. Today you're scraping along under 1,500 feet, but say next summer you take N5124K west over the mountains, cruising high. At what altitudes do the oxygen rules start to apply to you as the pilot, and to your passengers, and what does each one require?",
    "turn": 88
  },
  {
    "who": "applicant",
    "said": "I want to make sure I'm answering the right part—are you asking about the general regulatory altitudes, or are you asking me to apply those rules to a hypothetical flight profile where I'd be cruising high over mountains next summer?",
    "turn": 88
  },
  {
    "who": "examiner",
    "said": "The general rule. Give me the altitude thresholds in the regulation and what each one requires of you and of your passengers.",
    "turn": 89
  },
  {
    "who": "applicant",
    "said": "Above 12,500 feet MSL, the pilot must use supplemental oxygen if the flight exceeds 30 minutes; above 14,000 feet, oxygen is required immediately. Passengers must be offered oxygen above 15,000 feet, and above that altitude everyone on board must use it.",
    "turn": 89
  },
  {
    "who": "examiner",
    "said": "One fix: above 15,000 the passengers must be provided oxygen, but they aren't required to use it. Otherwise, good. That's the end of the oral, and we'll debrief.",
    "turn": 90
  },
  {
    "who": "applicant",
    "said": "Thank you. I appreciate the correction on the 15,000 foot rule—passengers must be provided oxygen but don't have to use it. I'm ready for the debrief.",
    "turn": 90
  },
  {
    "who": "examiner",
    "said": "Here's the debrief.\n\nThe big thing first: your weather judgment was good. You said no on that 2-degree spread, you stuck to your own limits under pressure from the passengers, and you diverted when Easton went down. That's what keeps people alive.\n\nThings to study tonight:\n\nOne. Airspace on your own route. Gaithersburg's surface is G, and over the bay at cruise you're in E. And the SFRA runs from the surface to FL180, so at 3,500 you're inside it, not under it.\n\nTwo. Wind triangles. Work out which side the wind is on before you crab, and remember winds aloft are given in true.\n\nThree. Ceilings are reported AGL. Add field elevation before you call anything MSL. And compare your planned cruise altitude to the ceiling before you file.\n\nFour. Inoperative equipment. A certificated pilot or a mechanic can make the hazard call. Nobody can placard away a required item.\n\nFive. Hazardous attitudes. Learn all five and their antidotes, and work out which one drives pushing on to get there.\n\nSix. PAVE versus ARROW. One is risk, one is documents. Don't mix them up.\n\nSeven. Know your airplane. It's fuel-injected, so there's no carb ice, and the annual on N5124K runs out next month. Track it.\n\nOverall, your knowledge of the regulations is decent, and your answers got sharper every time I pushed. Tighten up those details before the flight portion.",
    "turn": 91
  },
  {
    "who": "applicant",
    "said": "Thank you for the detailed feedback. I'm going to review those seven points tonight—especially airspace and the SFRA on my actual route, wind triangles with true winds aloft, and making sure I'm comparing ceiling AGL to my planned cruise altitude before I file.",
    "turn": 91
  },
  {
    "who": "examiner",
    "said": "Before you go, a couple more. Let's say the weather lifts and you do make it to Easton. Easton has a Class D around it. Before you cross into it, what has to happen on the radio for you to be legally inside?",
    "turn": 92
  },
  {
    "who": "applicant",
    "said": "I need to clarify—are you asking what I need to do before entering the Class D airspace itself, or what the tower needs to do before I can legally be inside it? I want to make sure I'm answering the right part.",
    "turn": 92
  },
  {
    "who": "examiner",
    "said": "Both, really. You call Easton Tower. What exactly does the tower have to say back for you to be allowed in? And do you need a clearance, the way you would for Baltimore's Bravo?",
    "turn": 93
  },
  {
    "who": "applicant",
    "said": "No, I don't need a clearance like Bravo. The tower has to give me a landing clearance or at least tell me to enter the Class D and report my position—basically, I need two-way radio contact and either a clearance to land or an instruction to enter. Once they acknowledge me and give me those instructions, I'm legal inside.",
    "turn": 93
  },
  {
    "who": "examiner",
    "said": "No. The tower doesn't have to give you an instruction or a landing clearance before you cross the boundary. Try this: you call up, and the tower answers, \"Aircraft calling Easton Tower, stand by.\" Can you go in? Now suppose instead they answer, \"Cessna Five One Two Four Kilo, stand by.\" Can you go in then? What's the difference?",
    "turn": 94
  },
  {
    "who": "applicant",
    "said": "Ah—I see the distinction now. In the first case, they didn't read back my call sign, so I don't have two-way radio contact established yet—I can't enter. In the second case, they read back my aircraft ID, so two-way radio contact is established, and I can enter the Class D. The key is established contact, not a clearance.",
    "turn": 94
  },
  {
    "who": "examiner",
    "said": "That's exactly it. Established contact, not a clearance. That's the end of the oral. Get some rest, and I'll see you at the airplane.",
    "turn": 95
  }
];

export const clarifications: Clarification[] = [
  {
    "sessionId": "20261001_190351_46ac35",
    "asked": "Morning. I'm ready whenever you are.",
    "examinerReplied": "Morning. Let's start with the trip itself. You've got two passengers riding along to Easton with you. Say they offer to chip in for the flight — what are you allowed to accept from them as a private pilot, and how does that split have to work?",
    "free": true
  },
  {
    "sessionId": "20261001_190351_46ac35",
    "asked": "Got it — so passengers can chip in on fuel, oil, airport fees, and rental. Pro rata split, and there's gotta be a legitimate reason we're all going. That makes sense.",
    "examinerReplied": "Okay. Different subject. On your logbook, the \"last flight review\" entry is empty. Does that matter for you flying N5124K to Easton today? Walk me through it.",
    "free": true
  },
  {
    "sessionId": "20261001_190351_46ac35",
    "asked": "Yeah, that makes sense — so once I pass today, I'm good to go as PIC. Thanks for clarifying that. I was thinking I'd need to schedule something separate after the checkride, but I get it now.",
    "examinerReplied": "Right. Now — you, personally, this morning. There's a standard self-assessment checklist pilots run on their own fitness before a flight. Name it and go through each thing it covers.",
    "free": true
  },
  {
    "sessionId": "20261001_190351_46ac35",
    "asked": "Oh, you're right — it's 500 feet below the clouds in Class E below 10,000, not a thousand. So with an overcast at 1,800, I'd need to stay at 1,300 or lower. I'm gonna have to revise my cruise altitude down to maybe 1,500 to give myself some buffer and still stay legal.",
    "examinerReplied": "Let's go slower on that. You just said you have to be at 1,300 or lower, then picked 1,500 \"for buffer.\" Put it together for me properly: the airspace along the route to Easton, the visibility and cloud clearances you need in it, and given an 1,800-foot overcast, what altitude actually keeps you legal.",
    "free": true
  },
  {
    "sessionId": "20261001_190351_46ac35",
    "asked": "Got it — Easton's its own tower, not the Academy. So I'm looking at Class D when I get there, and I need to contact them on approach. Thanks for the catch.",
    "examinerReplied": "Back to the uncontrolled airspace you mentioned. Class G minimums depend on two things — your height above the ground and the time of day. For this daytime flight, low under that overcast, give me the Class G numbers exactly, and say what height band they apply in.",
    "free": true
  },
  {
    "sessionId": "20261001_190351_46ac35",
    "asked": "You're right, I wasn't doing the math right. May 12th, 2025 to May 12th, 2026 — that's already gone. So the annual expires end of May this year, which means we're looking at maybe three weeks left. Yeah, that's tight. Definitely need to get that scheduled soon if I'm going to keep flying this plane.",
    "examinerReplied": "Set the airplane aside — it's legal. Your two passengers walk up and ask, \"Are we going?\" Looking at where this weather is heading over the next couple of hours, what's your answer to them, and why?",
    "free": true
  },
  {
    "sessionId": "20261001_190351_46ac35",
    "asked": "Okay, we're crossing the bay heading toward Easton. What's on your mind?",
    "examinerReplied": "I'll put it plainly. Easton's now reporting overcast at nine hundred and three miles in mist — below VFR for their airspace. You're twenty minutes out and you really want to get these folks there. Is there a name for that urge to keep going, and what are you going to do?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "Morning. I'm ready whenever you are.",
    "examinerReplied": "Morning. Let's start with your two passengers to Easton. If they offer to chip in for the trip, what can you legally accept from them as a private pilot, and where's the line?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I need to clarify — are you asking what costs I can split if I'm renting the airplane, or are you asking about the operating costs of this specific flight in N5124K? Because if I'm renting, the rental fee itself is one thing, but if I'm talking about what we split on a flight I'm operating, that's different.",
    "examinerReplied": "Fair question. Forget whether it's rented or owned for a moment. The regulation lists specific kinds of expenses a private pilot can share with passengers. I want that list. Which categories of cost does the rule allow, and is there anything else the flight has to meet before you can share costs at all?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I want to make sure I'm answering what you're asking. Are you asking me to name the specific FAA exceptions where a private pilot can be paid or reimbursed — like Part 61.113(c) situations — or are you asking which of those examples you mentioned I'm allowed to do today on this flight?",
    "examinerReplied": "The first one. Leave today's flight aside. In general, what are the exceptions where a private pilot may be paid or reimbursed, and how broad is that list?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I need to narrow this down—are you asking me which certificated persons can make that hazard determination in general under the rule, or are you asking specifically who *I* can delegate it to before I fly today?",
    "examinerReplied": "In general, under the rule. Who, by certificate, is allowed to decide the inoperative item isn't a hazard?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I want to make sure I'm reading this right—are you asking me about the general VFR minimums for Class E airspace, or are you asking specifically where on my route today I'd be flying in Class E and what I need to do there?",
    "examinerReplied": "Start with the general rule. In Class E below 10,000 feet, what visibility do you need, and how far do you have to stay from clouds? Then we'll put it on today's 1,800-foot overcast.",
    "free": false
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "In Class E airspace below 10,000 feet, VFR minimums are 3 statute miles visibility and 500 feet below, 1,000 feet above, and 2,000 feet horizontal distance from clouds.",
    "examinerReplied": "Take those Class E numbers and put them on today. The overcast is at 1,800 feet AGL and visibility is 5 miles. What's the highest altitude you can legally cruise at in Class E between Gaithersburg and Easton, and why?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "Are you asking which controlled airspace classes use those same minimums—3 statute miles visibility, 500 below, 1,000 above, 2,000 horizontal—or are you asking specifically about the airspace I'll be flying through on today's route?",
    "examinerReplied": "The general one. Which airspace classes share those exact numbers?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "Before I answer, I need to clarify what you're asking. When you say 'when you'd turn for it,' do you mean under what specific condition — like if I lose an engine, or if the weather deteriorates below minimums at my destination, or if I get a TFR closure along my route? Because that changes which alternate I'd pick and when I'd commit to it. Also, I should say I have the chart here in front of me, but I want to make sure I'm looking at the right thing: are you asking me to justify why each one qualifies as a legal alternate — meaning it meets fuel and weather minimums — or are you asking me to walk through my decision logic in the air if things go wrong? Those aren't the same thing.",
    "examinerReplied": "Your decision-making in the air. Picture the weather getting worse: the ceiling lowering over the bay, or Easton going below VFR before you get there. Which of those three airports do you go to in each case, and what makes each one a good place to land? Think about runways, fuel, services and approaches.",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I need to clarify something—when you say 'Salisbury,' are you referring to KSBY, which I do have listed as my third alternate? And when you ask what I'd do if Easton reports 800 overcast, I'm assuming you mean I'm already committed past the bay with limited fuel to turn back—so KSBY is my last-resort alternate if I can't get into Easton.",
    "examinerReplied": "Yes, KSBY. And you're not short on fuel. Your plan shows plenty on board. So tell me why you'd pick Salisbury specifically, and what about it you checked before we left today.",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I want to make sure I'm reading this right—the winds aloft on my sheet show 0915 at 3,000 feet, which is 090 at 15 knots. But my cruise altitude is 3,500 feet. Should I use the 3,000-foot winds you just gave me, or should I interpolate between the 3,000 and 6,000-foot winds on my actual flight plan?",
    "examinerReplied": "Use the 3,000-foot wind. Given the ceiling, that's closer to where you'll really be anyway. Say you're cruising around 110 knots. Talk me through how you get from that and the wind to a groundspeed, a heading, and a time for the 64 miles.",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "Got it—thank you. So once I'm at 3,500 feet over the bay, I'm in Class E airspace. The Class G only exists below that floor up from the surface. I'll make sure I have that clear for the actual flight.",
    "examinerReplied": "Right. Now my question: what equipment does the airplane need to have working for the airspace you'll be in today? Think about what lets ATC see you.",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I need to clarify—are you asking what the rule requires inside Class B airspace in general, or are you asking what I need given that I'm VFR and the forecast shows 5 statute miles visibility with an 1800-foot ceiling? Those give different answers.",
    "examinerReplied": "The rule itself. What visibility and cloud clearance does the regulation require inside Class B, and how is that different from the Class E numbers you gave me earlier?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "You're right, I need to be more careful here. Are you asking me to state the distance rule that applies in Class C, D, and E all together as one rule, or are you asking me to distinguish between what's required in each of those three airspaces separately?",
    "examinerReplied": "As one rule. They share it. Give me the cloud distances, all three, and contrast them with Bravo.",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I want to make sure I'm understanding the four categories correctly—are you asking me to frame this as pilot, aircraft, environment, and external pressures? Or is there a specific risk framework you're referring to that I should be using?",
    "examinerReplied": "Yes, those four. Go through them one at a time, each tied to something real about today.",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "You're right—airframe ice is the real threat at this altitude with that spread. My rear passengers are here waiting, and that's pressure I need to recognize and not let drive the decision.",
    "examinerReplied": "And the name of that four-part checklist?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "Got it—PAVE. Pilot, aircraft, environment, external pressures. I see it now. I'm ready to go through the startup checklist when you are.",
    "examinerReplied": "Before we start, one question about this engine. Older 172s have a carb-heat knob. Where is it on this panel? If it isn't there, why not, and what protects the induction if it ices up or gets blocked?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I need to clarify — when you say 'the vacuum pump died,' do you mean it failed during flight today, or are you asking me a general question about which instruments would fail if the vacuum pump quit? That changes which instruments I'd be talking about.",
    "examinerReplied": "Forget the vacuum pump for now. Just this: what's spinning inside each of those three instruments, and why does it need to spin to work?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I need to clarify what you're asking—do you mean how I should have monitored the weather continuously from preflight through engine start to catch the change, or are you asking about the decision-making process itself once I'm airborne and see the ceiling is actually lower than forecast? Those are different timelines.",
    "examinerReplied": "One note on the attitude you named: the one you picked is about thinking accidents happen to other people. Pushing on to get there usually comes from a different one. Look it up tonight. On my question, I mean the decision-making itself. Is go/no-go one decision you make on the ground, or something else? How does it work once you're airborne?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I need to clarify—when you say 'what do you turn off,' do you mean what avionics and systems, or are you asking about the order and logic of what stays powered for the rest of the flight? I want to make sure I'm thinking about this the right way before I answer.",
    "examinerReplied": "The logic. You have a battery that will only last so long, and a towered airport to get into. Name the specific things you'd switch off, the things you'd keep on, and why.",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I want to make sure I'm answering the right part—are you asking about the general regulatory altitudes, or are you asking me to apply those rules to a hypothetical flight profile where I'd be cruising high over mountains next summer?",
    "examinerReplied": "The general rule. Give me the altitude thresholds in the regulation and what each one requires of you and of your passengers.",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "Thank you. I appreciate the correction on the 15,000 foot rule—passengers must be provided oxygen but don't have to use it. I'm ready for the debrief.",
    "examinerReplied": "Here's the debrief.\n\nThe big thing first: your weather judgment was good. You said no on that 2-degree spread, you stuck to your own limits under pressure from the passengers, and you diverted when Easton went down. That's what keeps people alive.\n\nThings to study tonight:\n\nOne. Airspace on your own route. Gaithersburg's surface is G, and over the bay at cruise you're in E. And the SFRA runs from the surface to FL180, so at 3,500 you're inside it, not under it.\n\nTwo. Wind triangles. Work out which side the wind is on before you crab, and remember winds aloft are given in true.\n\nThree. Ceilings are reported AGL. Add field elevation before you call anything MSL. And compare your planned cruise altitude to the ceiling before you file.\n\nFour. Inoperative equipment. A certificated pilot or a mechanic can make the hazard call. Nobody can placard away a required item.\n\nFive. Hazardous attitudes. Learn all five and their antidotes, and work out which one drives pushing on to get there.\n\nSix. PAVE versus ARROW. One is risk, one is documents. Don't mix them up.\n\nSeven. Know your airplane. It's fuel-injected, so there's no carb ice, and the annual on N5124K runs out next month. Track it.\n\nOverall, your knowledge of the regulations is decent, and your answers got sharper every time I pushed. Tighten up those details before the flight portion.",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "Thank you for the detailed feedback. I'm going to review those seven points tonight—especially airspace and the SFRA on my actual route, wind triangles with true winds aloft, and making sure I'm comparing ceiling AGL to my planned cruise altitude before I file.",
    "examinerReplied": "Before you go, a couple more. Let's say the weather lifts and you do make it to Easton. Easton has a Class D around it. Before you cross into it, what has to happen on the radio for you to be legally inside?",
    "free": true
  },
  {
    "sessionId": "20261001_190352_19fce4",
    "asked": "I need to clarify—are you asking what I need to do before entering the Class D airspace itself, or what the tower needs to do before I can legally be inside it? I want to make sure I'm answering the right part.",
    "examinerReplied": "Both, really. You call Easton Tower. What exactly does the tower have to say back for you to be allowed in? And do you need a clearance, the way you would for Baltimore's Bravo?",
    "free": false
  },
  {
    "sessionId": "20261001_190353_1bd997",
    "asked": "Morning. I'm ready whenever you are.",
    "examinerReplied": "Morning. Let's start with the trip itself — you're taking two passengers to Easton. If they offer to chip in for the flight, what can you accept from them, and what's the limit on that as a private pilot?",
    "free": true
  },
  {
    "sessionId": "20261001_190353_1bd997",
    "asked": "Got it—I hear you, I was mixing that up. So it has to be incidental to the job, not the main purpose. I'll definitely review that section. Thanks for the correction.",
    "examinerReplied": "No problem. Now, the airplane. Suppose during your preflight you find the cabin dome light doesn't work. Before you can take off, what's the process you go through to decide if this 172 is still legal to fly to Easton?",
    "free": true
  },
  {
    "sessionId": "20261001_190353_1bd997",
    "asked": "Got it — cabin or cockpit entrance, legible to passengers and crew. Okay, I'm ready to go through the weather.",
    "examinerReplied": "Good. With 5 miles and an 1800-foot overcast today, take me along the route from Gaithersburg to Easton. What classes of airspace do you pass through, and how does that change which VFR weather minimums you have to meet from one stretch to the next?",
    "free": true
  },
  {
    "sessionId": "20261001_190353_1bd997",
    "asked": "Got it — 500 below, 1,000 above, 2,000 horizontal in C, D, and E. And clear of clouds in the Bravo. I'll keep those straight.",
    "examinerReplied": "Good. Now — on a nice day, why would 3,500 MSL be a sensible pick for this particular trip? Think about your course of 125, the terrain, and that crossing of the Chesapeake.",
    "free": true
  },
  {
    "sessionId": "20261001_190353_1bd997",
    "asked": "Okay, sounds good. I'm ready when you are.",
    "examinerReplied": "Point to them for me. Which instruments on this panel run on a spinning gyro, and what does each one tell you?",
    "free": true
  },
  {
    "sessionId": "20261001_190353_1bd997",
    "asked": "Okay, I'm ready. What do you want to know?",
    "examinerReplied": "Oxygen. In an unpressurized airplane like this one, at what altitudes does the regulation require you, the pilot, to use supplemental oxygen — and is there a time allowance at any of them? And at what altitude do your passengers have to be provided with it?",
    "free": true
  },
  {
    "sessionId": "20261001_190353_1bd997",
    "asked": "Okay, so conditions are better now and I'm cleared to land at Easton. What do you want me to talk through — the approach, the landing itself, or something about the field?",
    "examinerReplied": "Something specific. You're on the descent into Easton, power back, nose down — and the airspeed needle is behaving strangely, but the altimeter and vertical speed look perfectly normal. In this cold, wet air, what's likely blocked? And walk me through what the airspeed indicator does if that blockage is total versus if just the front opening is blocked.",
    "free": true
  },
  {
    "sessionId": "20261001_190353_1bd997",
    "asked": "Yeah, that makes sense — the static pressure is changing but the pitot side is locked, so the differential pressure changes with altitude. I'll definitely go back through that before the next one.",
    "examinerReplied": "Now the landing. Runway 4 at Easton, wind 090 at 16. Start with the crosswind: roughly how much of that is across the runway, and how does that compare to the crosswind figure in this airplane's handbook?",
    "free": true
  }
];

export const proofMoments: ProofMoment[] = [
  {
    "id": "vague",
    "sessionId": "20261001_190351_46ac35",
    "applicant": "Yeah, so as a private pilot I can split the direct operating costs with my passengers — fuel, oil, that kind of thing — but I can't make a profit on the flight. Since there's two of them and just me, I'd divide the total cost by three and charge each passenger their share.",
    "examiner": "You said \"fuel, oil, that kind of thing.\" Be specific for me. If you're renting N5124K for this trip and Easton charges a ramp fee, what exactly goes into that pot you're dividing by three — and what can't?"
  },
  {
    "id": "annual",
    "sessionId": "20261001_190352_19fce4",
    "applicant": "Okay. Pilot: I have only 12 hours PIC and no flight review yet, so my experience is below what I'd want for MVFR and icing risk. Aircraft: the annual inspection expires in about five months, and I'm already at gross weight with rear passengers, so I have no margin for error.",
    "examiner": "Check the date on that annual: May 12th of last year. That's not five months away, it runs out at the end of next month. It's legal today, but it's close. Now finish the other two: environment, and the external pressures. What are they today?"
  },
  {
    "id": "carb",
    "sessionId": "20261001_190352_19fce4",
    "applicant": "Environment: we're looking at MVFR with icing risk and a 2-degree spread, so fog is real and carburetor ice is a genuine threat at 3,500 feet. External pressures: I have friends and family waiting at Easton, which makes me want to press on if conditions get marginal, and I know my experience is limited, so I need to be honest about turning back if",
    "examiner": "One thing: N5124K has a fuel-injected IO-360, so there's no carburetor to ice. Airframe ice is the threat. And your external pressure isn't only at Easton. Who's sitting in this lobby right now with their bags, and how does that push on you? Last, what's the four-letter name of the checklist you just ran?"
  },
  {
    "id": "sfra",
    "sessionId": "20261001_190351_46ac35",
    "applicant": "Okay, good point. So leaving Gaithersburg I'm in the DC SFRA — that's Class B airspace, so I need three miles visibility and I have to stay 500 below, 1,000 above, 2,000 horizontal. Then once I'm past the Bravo shelf, I'm in Class E, same requirements — three miles vis, 500 below, 1,000 above.",
    "examiner": "Two corrections. The SFRA isn't an airspace class — it's a special-rules area laid over whatever's underneath — and Class B minimums aren't the same as E anyway; it's clear of clouds. So: at 1,300 feet or less, what airspace is sitting right near the surface in the country between here and the bay, and what is Easton itself? And do any of those carry minimums different from Class E?"
  },
  {
    "id": "attitudes",
    "sessionId": "20261001_190352_19fce4",
    "applicant": "That's get-there-itis—I want to land there because my friends are expecting dinner and we're close. But I'm not landing in 900-foot overcast; that's instrument conditions. I'm diverting to one of my alternates—Annapolis or Cambridge—where the weather is VFR, and letting them know what's happening.",
    "examiner": "Good call. Get-there-itis isn't one of the five hazardous attitudes on its own. Which of the five does it grow out of? And with 55 hours, how do the limits you set on the ground fit into that decision when your friends are leaning on you?"
  },
  {
    "id": "placard",
    "sessionId": "20261001_190353_1bd997",
    "applicant": "Oh — it has to be in a place where the pilot can see it, doesn't it? Like on the instrument panel or somewhere the PIC can read it before flight?",
    "examiner": "Not quite — it has to be displayed at the cabin or cockpit entrance, legible to the passengers and crew. Not tucked on the panel for the pilot. Alright, let's sit down and go through the weather you pulled."
  },
  {
    "id": "oneshort",
    "sessionId": "20261001_190351_46ac35",
    "applicant": "Yeah, so the attitude indicator and the heading indicator — those are your gyros. The attitude indicator uses precession to show pitch and bank, and the heading indicator uses rigidity in space to hold its heading reference.",
    "examiner": "You're one short. Earlier, with the dead vacuum pump, you named an instrument you said still works because it's electric. That one has a gyro in it too. Name all of them now, and tell me what each one actually shows you. And rethink the attitude indicator — is precession really what lets it hold the horizon?"
  },
  {
    "id": "halfright",
    "sessionId": "20261001_190351_46ac35",
    "applicant": "Okay, so if both are blocked, the pitot pressure's trapped inside — it doesn't change with dynamic pressure anymore. In a climb, as static pressure drops, that trapped pitot pressure becomes relatively higher than the static side, so the airspeed needle starts climbing even though you're slowing down.",
    "examiner": "Climb half is right. The other half: in a descent the trapped pressure makes it read low, so it behaves like an altimeter. Altimeter and VSI run off the static port only, so a pitot blockage doesn't touch them. And for the record, the scenario I gave you, airspeed climbing in a descent, doesn't fit a fully blocked pitot. Cross-check before you trust any one needle. That's us on the ground at Easton. Let's take a break before we go fly."
  }
];

export const measured = {
  "exams": 3,
  "ranInParallel": true,
  "totalTurns": 271,
  "totalUtterances": 496,
  "itemsAsked": 90,
  "zeroCredit": 0,
  "medianTurnSecs": 8.2,
  "p95TurnSecs": 12.4,
  "turnsMeasured": 241,
  "clarifications": 38,
  "clarificationsFree": 36,
  "sourceDate": "2026-10-01"
};
